import { IClient } from '@frontend/app/hooks';

export const buildInstagramDefaultFiltersPrompt = (client?: IClient): string => {
  const lines = [
    'Generate default search filters for discovering Instagram creators that align with this brand.',
    `name: ${client?.name ?? 'N/A'}`,
    `category: ${client?.brandCategory ?? 'N/A'}`,
    `summary: ${client?.summary ?? 'N/A'}`,
    'Only include creators that are in the Instagram Creator Marketplace.',
    'Exclude audience demographic filters.',
    'Exclude the brand name from the free text query.',
  ];

  return lines.join(' | ');
};
